import { Injectable } from '@angular/core';

@Injectable()
export class DialogDeleteService {

  constructor() { }

  alertDelete(modalData: any) {
     console.log('modal--------->>>', modalData);
  }
}
